import { z } from 'zod';

import {
  type ValueType,
  ValueType as VT,
  type ValueTypeFilter,
} from './-query/type';

const valueTypeValues = Object.values(VT) as [ValueType, ...ValueType[]];

export const ValueTypeFilterSchema = z.enum(['ALL', ...valueTypeValues]);

/**
 * 価値一覧の種別タブ並び順:
 *   約束 → 仮説（検証済）→ 仮説（未検証）→ 種 → すべて
 * （デフォルトは「価値約束」）
 *
 * フェーズの確度が高い順に左から並べる。検証済は未検証の仮説より約束に近いため
 * 仮説（未検証）の手前に置く。
 */
export const VALUE_TYPE_TABS = [
  VT.PROMISE,
  VT.HYPOTHESIS_VERIFIED,
  VT.HYPOTHESIS,
  VT.SEED,
  'ALL',
] as const satisfies readonly ValueTypeFilter[];

export function buildValueTabChangeSearch(tab: string) {
  const result = ValueTypeFilterSchema.safeParse(tab);
  return {
    valueType: result.success ? result.data : ('ALL' as const),
    pageIndex: 0,
    sortColumn: undefined,
    orderDirection: 'desc' as const,
  };
}
